import { CircleHalfIcon } from "@phosphor-icons/react/dist/csr/CircleHalf";
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { Text } from "@volca/ui/components/ui/text";
import { useTheme } from "@volca/ui/theme";

const THEMES = [
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
  { value: "system", label: "System" },
] as const;

export const ThemeMenu = () => {
  const { theme, setTheme } = useTheme();
  const current = THEMES.find((option) => option.value === theme);

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <CircleHalfIcon />
        {/* The label grows so the value sits beside the trigger's own caret. */}
        <Text render={<span />} className="flex-1">
          Theme
        </Text>
        <Text render={<span />} tone="muted">
          {current?.label}
        </Text>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="min-w-32">
        <DropdownMenuRadioGroup
          value={theme}
          onValueChange={(value) => {
            const next = THEMES.find((option) => option.value === value);
            if (next) setTheme(next.value);
          }}
        >
          {THEMES.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              <Text render={<span />}>{option.label}</Text>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
